<div class="slider__search">
  <app-search-request [fc]="fc" [searchOnChanges]="false" />

  <div (click)="onSearch(fc.value)" class="slider__search-button">
    <img
      src="assets/icon-search.svg"
      width="512"
      height="512"
      alt="Search icon"
    />
  </div>
</div>
